/**
 * open-sky-addons.js
 * Configurator UI for Open Sky product page (product.open-sky).
 * Add-ons cart submit + totals, tabs.
 */

(function () {
  'use strict';

  var container = document.getElementById('osky-addons');
  if (!container) return;

  var grandTotalEl = document.getElementById('osky-grand-total');
  var addonLine = document.getElementById('osky-addon-line');
  var addonTotalEl = document.getElementById('osky-addon-total');
  var mainPriceHolder = document.getElementById('osky-main-price-cents');

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getMainPriceCents() {
    if (mainPriceHolder && mainPriceHolder.getAttribute('data-cents')) {
      return parseInt(mainPriceHolder.getAttribute('data-cents'), 10) || 0;
    }
    var base = container.getAttribute('data-base-cents');
    return base ? parseInt(base, 10) || 0 : 0;
  }

  function setMainPriceCents(cents) {
    if (mainPriceHolder) {
      mainPriceHolder.setAttribute('data-cents', String(cents));
    }
    container.setAttribute('data-base-cents', String(cents));
  }

  function syncVariantPriceFromForm() {
    var form = document.querySelector('form[data-add-to-cart-form], form.product-single__form');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!idInput || !variantJsonEl) return;
    try {
      var variants = JSON.parse(variantJsonEl.textContent || '[]');
      var id = parseInt(idInput.value, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) {
          setMainPriceCents(variants[i].price);
          return;
        }
      }
    } catch (e) {
      /* ignore */
    }
  }

  function getAddonItems() {
    var items = [];
    var checked = container.querySelector('input[name="osky-back-wall"]:checked');
    if (checked && checked.value !== '') {
      var wallId = parseInt(checked.value, 10);
      if (wallId > 0) {
        items.push({ id: wallId, quantity: 1 });
      }
    }
    container.querySelectorAll('.osky-circle-qty').forEach(function (card) {
      var qty = parseInt(card.querySelector('.osky-stepper__input').value, 10) || 0;
      var vid = parseInt(card.dataset.variant, 10);
      if (qty > 0 && vid > 0) {
        items.push({ id: vid, quantity: qty });
      }
    });
    return items;
  }

  function calcAddonTotal() {
    var total = 0;
    var checked = container.querySelector('input[name="osky-back-wall"]:checked');
    if (checked && checked.value !== '') {
      var wallId = parseInt(checked.value, 10);
      if (wallId > 0) {
        total += parseInt(checked.dataset.price, 10) || 0;
      }
    }
    container.querySelectorAll('.osky-circle-qty').forEach(function (card) {
      var qty = parseInt(card.querySelector('.osky-stepper__input').value, 10) || 0;
      var vid = parseInt(card.dataset.variant, 10);
      if (qty > 0 && vid > 0) {
        total += qty * (parseInt(card.dataset.price, 10) || 0);
      }
    });
    return total;
  }

  function updateTotals() {
    var addon = calcAddonTotal();
    var main = getMainPriceCents();
    if (grandTotalEl) {
      grandTotalEl.textContent = formatMoney(main + addon);
    }
    if (addonLine && addonTotalEl) {
      if (addon > 0) {
        addonTotalEl.textContent = '+' + formatMoney(addon);
        addonLine.hidden = false;
      } else {
        addonLine.hidden = true;
      }
    }
  }

  function refreshQtyRing(card) {
    var qty = parseInt(card.querySelector('.osky-stepper__input').value, 10) || 0;
    card.classList.toggle('is-active', qty > 0);
  }

  /* ── Tabs ───────────────────────────────────────────────── */
  var tabRoot = container.querySelector('[data-osky-tabs]');
  if (tabRoot) {
    var tabs = tabRoot.querySelectorAll('.osky-tabs__tab');
    var panels = tabRoot.querySelectorAll('.osky-tabs__panel');

    function activateTab(name) {
      tabs.forEach(function (tab) {
        var is = tab.getAttribute('data-osky-tab') === name;
        tab.classList.toggle('is-active', is);
        tab.setAttribute('aria-selected', is ? 'true' : 'false');
        tab.setAttribute('tabindex', is ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var is = panel.getAttribute('data-osky-panel') === name;
        panel.classList.toggle('is-active', is);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-osky-tab'));
      });
    });
  }

  /* ── Bind inputs ────────────────────────────────────────── */
  container.querySelectorAll('input[name="osky-back-wall"]').forEach(function (radio) {
    radio.addEventListener('change', updateTotals);
  });

  container.querySelectorAll('.osky-circle-qty').forEach(function (card) {
    var input = card.querySelector('.osky-stepper__input');
    var minus = card.querySelector('.osky-stepper__btn--minus');
    var plus = card.querySelector('.osky-stepper__btn--plus');

    plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      refreshQtyRing(card);
      updateTotals();
    });

    minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 0;
      if (v > 0) input.value = v - 1;
      refreshQtyRing(card);
      updateTotals();
    });

    input.addEventListener('input', function () {
      if ((parseInt(input.value, 10) || 0) < 0) input.value = 0;
      refreshQtyRing(card);
      updateTotals();
    });
    refreshQtyRing(card);
  });

  var productForm = document.querySelector('form[data-add-to-cart-form], form.product-single__form');
  if (productForm) {
    productForm.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        syncVariantPriceFromForm();
        updateTotals();
      }
    });
  }

  syncVariantPriceFromForm();
  updateTotals();

  /* ── Cart submit ───────────────────────────────────────── */
  var form = document.querySelector('form[data-add-to-cart-form], form.product-single__form');
  if (!form) return;

  var oskyAddInFlight = false;
  var lastSubmitAt = 0;

  function handleAddToCart(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    var now = Date.now();
    if (oskyAddInFlight || now - lastSubmitAt < 900) {
      return;
    }
    lastSubmitAt = now;

    var variantInput = form.querySelector('[name="id"], [data-product-select]');
    var mainId = variantInput ? parseInt(variantInput.value, 10) : null;
    var mainQty = 1;

    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = '1';
    }

    var items = mainId ? [{ id: mainId, quantity: mainQty }] : [];
    items = items.concat(getAddonItems());
    if (items.length === 0) return;

    oskyAddInFlight = true;

    var btn = form.querySelector('[data-add-to-cart], [name="add"]');
    var btnTextEl = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
    var originalText = btnTextEl ? btnTextEl.textContent : btn ? btn.textContent : '';
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (d) {
            throw new Error(d.description || 'Cart error');
          });
        }
        return res.json();
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
      })
      .catch(function (err) {
        console.error('[open-sky-addons]', err);
        alert(err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        oskyAddInFlight = false;
        if (btn) btn.disabled = false;
        if (btnTextEl) btnTextEl.textContent = originalText;
        else if (btn) btn.textContent = originalText;
      });
  }

  form.addEventListener('submit', handleAddToCart, true);
  var addButtons = form.querySelectorAll('[data-add-to-cart], [name="add"], button[type="submit"]');
  addButtons.forEach(function (b) {
    b.addEventListener('click', handleAddToCart, true);
  });
})();

